$(document).ready(function() {

  var seller_mail_id;
  var seller_password;
  var userName;
  var isBankDetailsSet;
  var isPolicySet;

  function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0)
        return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  if ($('.login-popup').length) {
    if ($(".seller_login_button").length) {
      $('.seller_login_button').click(function() {
        var loginPopup = $('.login-popup');
        loginPopup.bPopup({
          positionStyle: 'fixed',
          scrollBar: 'true',
          closeClass: 'modal__close'
        });
        loginSubmit();
      });
    }

    /*
    	Show Designer login pop-up automatically if the url has the specific parameter 
    */
    var regularExpressionLoginPopup = new RegExp(".*#designer-login$");
    if (regularExpressionLoginPopup.test(window.location.href)) {
      if (readCookie('first_name') != null && readCookie('seller_email') != null && readCookie('brand_name') != null && readCookie('session_token') != null) {
        //already loggedin, Don't do anything
      } else {
        var loginPopup = $('.login-popup');
        loginPopup.bPopup({
          positionStyle: 'fixed',
          closeClass: 'modal__close'
        });

        loginSubmit();
      }
    }

    /*
    	Show Designer clear cookie and redirect to loginpage automatically if the url has the specific parameter 
    */
    var regularExpressionLoginPopup = new RegExp(".*#logout$");
    if (regularExpressionLoginPopup.test(window.location.href)) {
      
        deleteAllCookies();
        var loginPopup = $('.login-popup');
        loginPopup.bPopup({
          positionStyle: 'fixed',
          closeClass: 'modal__close'
        });
        loginSubmit();
    }
  }
  
   function deleteAllCookies() {
            var cookies = document.cookie.split(";");

            for (var i = 0; i < cookies.length; i++) {
                var cookie = cookies[i];
                var eqPos = cookie.indexOf("=");
                var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
                document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
            }
        }
     
     //Forgot password
  $('.forgot_password').click(function() {
        var forgotPasswordPopup = $('.forgot_password_popup');
        $('.login-popup').bPopup().close();
        forgotPasswordPopup.bPopup({
          positionStyle: 'fixed',
          scrollBar: 'true',
          closeClass: 'modal__close'
        });
	}); 
  
  $('.forgot_password_email_submit').click(function(){
    var recoveryEmail =  $('#forgot_password_email').val();
    var forgotPasswordUrl = "https://test-designers.lovethisstuff.com/login/sendSellerForgotPasswordEmail?email=" + recoveryEmail;
  $('#recoveryEmailMessage').html('');
  $('#recoveryEmailMessageError').html('');
    $(this).hide();
    $.ajax({
          url: forgotPasswordUrl,
          type: 'GET',
          processData: false,
          async: false,
          success: function(data) {
            var messageType = data.messageType;
            var message = data.message;
            console.log(data);
            if (messageType == 'FAILURE') {
              $('#recoveryEmailMessageError').html(message).fadeIn();
            } 
            else if (messageType == 'SUCCESS') {
              //resent password Email had been sent to your emailid. 
              $('#recoveryEmailMessage').html(message).fadeIn();
              $('.forgot_password_popup').bPopup().delay(1000).close();
            }
       	},
          error: function(data) {
            console.log("Error: " + data);
          }
        });
	   

    $(this).show();
    
  });
  

  //If user is logged in hiding the login, register button  and displaying Information bar message
  if (readCookie('brand_name') != null) {
//     $('.seller_login_button').hide();
//     $('.seller_register_button').hide();
//     $('.seller_logout_button').show();
//     $('#seller_logged_in_tab').show();
//     $('#seller_logged_out_tab').hide();
    $('.seller_login_button').hide();
    $('.seller_register_button').hide();
    $('.seller_logout_button').show();
    $('#seller_logged_in_tab').show();
    $('.seller_logged_in_tab').show();
    $('#seller_logged_out_tab').hide();
    $('.seller_logged_out_tab').hide();
    

    var firstName = readCookie('first_name');
    var businessName = readCookie('brand_name');
    var brandName = readCookie('brand_name');

    $('.seller_user_name').html(businessName);
    var maxBrandNameLength = 8;
    if (brandName.length > maxBrandNameLength) {
      var displayBrandName = brandName.substring(0, maxBrandNameLength - 2) + "..";
    } else {
      var displayBrandName = brandName;
    }
    $('.seller_business_name').html(displayBrandName);
    $('.seller_page_link').prop('href', 'https://qa-lts3.myshopify.com/collections/vendors?q=' + encodeURI(brandName));

    var mypageURL = "https://qa-lts3.myshopify.com/collections/vendors?q=" + encodeURI(brandName);
    $('#myShop').attr( "href", mypageURL );
    $('.seller_home').attr( "href", mypageURL );
    $('.seller_home').show();
    $('.seller_dashboard').show();
    $('#default_message').hide();
    $('#welcome_message').show();
  } else {
    $('#seller_logged_in_tab').hide();
    $('#seller_logged_out_tab').show();
    $('.seller_logout_button').hide();
    $('.seller_home').hide();
    $('.seller_dashboard').hide;
    $('.seller_login_button').show();
    $('.seller_register_button').show();
    $('.seller_logged_in_tab').hide();
    $('.seller_logged_out_tab').show();
  }

  // login form validate
  $('.error_check').click(function(e) {
    e.preventDefault();

    //Validating values
    if (loginValidation()) {
      $(".error_tag").fadeOut();
    }
  });


  //Validating register form
  function loginValidation() {
    var filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;

    var seller_login_mail_id = $('#seller_mail_id').val(),
        seller_login_password = $('#seller_password').val();
    $(".error_tag").hide();

    if (seller_login_mail_id == "") {
      $('#seller_mail_id').focus();
      $("#seller_login_mail_id_error").fadeIn().html("Please enter your Email Id");
      return false;
    } else if (!filter.test(seller_login_mail_id)) {
      $('#seller_mail_id').focus();
      $("#seller_login_mail_id_error").fadeIn().html("Please provide a valid email address");
      return false;
    }

    if (seller_login_password == "") {
      $('#seller_login_password').focus();
      $("#seller_login_password_error").fadeIn().html("Please enter Password");
      return false;
    }

    return true;
  }


  //Calling API to login
 
 
function loginSubmit() {
$("form#login_submit").submit(function(e){
	e.preventDefault();
	$(".loging_container").fadeIn();
	var loginSubmitBtn = $('#login_button');
	$(".loging_container").show();
	loginSubmitBtn.html('Submitting...');
	loginSubmitBtn.prop('disabled',true);
	loginSubmitBtn.attr('disabled',true);
	var formData = new FormData($("#login_submit")[0]);
	var seller_mail_id = document.getElementById('seller_mail_id').value;
 
    var seller_password = document.getElementById("seller_password").value;
 
    var sessionId = readCookie('session_token');
	formData.append('userName',seller_mail_id );
	formData.append('password',seller_password );
	
	
    formData.append('ajaxRequest', 'yes');
  
  
  
  		var postData = new Object();
        postData.username = seller_mail_id;
        postData.password=seller_password;
        
        var jsonPostData = JSON.stringify(postData);
        var post = $.ajax({
            type: "POST",
            url: 'https://api-test.lovethisstuff.com/v1/users/login', 
            data: jsonPostData,
            contentType: 'application/json'
        });
        post.always(function(data) {
            if(data['status'] === "SUCCESS") {
              
               $(".RegisterText").hide();
               $('.api_success').html('You are successfully logged in');
               $('.api_error').hide();
               $('.api_success').fadeIn();
              
               $('.login_inputs').hide();
               $('.seller_login_button').hide();
               $('.seller_register_button').hide();
               $('.seller_logout_button').show();
               $('.seller_home').show();
               $('.seller_dashboard').show;
               $('.change_password_button').show();
               $('#informationBarOrderButton').show();
              
                brandName = data.data.userDetails.profile_name;
              
               var businessPage = 'https://qa-lts3.myshopify.com/collections/vendors?q=' + encodeURI(brandName);

                            
              $("#login_popup").hide();
              setTimeout(function() {
                $('.login-popup').bPopup().close();
              }, 2000);
              
                createCookie('brand_name', data.data.userDetails.profile_name, 30);
                 createCookie('token', data.data.token, 30);

 				location.reload();
              window.location.href = businessPage;
              //  location.reload();
            } else if(data.responseJSON.status === "failed"){
              $('.api_error').html(data.responseJSON.message);
              $('.api_success').hide();
              $('.api_error').fadeIn();
            }
            
        }); 

	return false;
      });
    }

  
  $('.seller_home').click( function() {
    var brandName = readCookie('brand_name');
    var brandPage = 'https://qa-lts3.myshopify.com/collections/vendors?q=' + encodeURI(brandName);
    window.location.href = brandPage;
  });
  
 	/*
    Show forgot password popup if the URL contains parameters set
    */
    var url = window.location.href; // gets current url
   	if(window.location.href.indexOf("ltsfpe") > -1) {
       var recoveryEmail = getParameterByName('ltsfpe');
       var token = getParameterByName('token');
       var firstName = getParameterByName('firstName');
       var lastName =  getParameterByName('lastName');
       var brandName =  getParameterByName('brandName');
        deleteAllCookies();
       createCookie('seller_email', recoveryEmail, 30);
       createCookie('session_token', token, 30);
       createCookie('first_name', firstName, 30);
       createCookie('last_name', lastName, 30);
       createCookie('brand_name', brandName, 30);

       window.location.href = 'https://qa-lts3.myshopify.com/collections/vendors?q='+ brandName +'#reset-password';  
    }
    
    function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
   }
    
    /*
    Show Designer reset password pop-up automatically if the url has the specific parameter 
    */
    var regularExpressionLoginPopup = new RegExp(".*#reset-password$");
    if (regularExpressionLoginPopup.test(window.location.href)) {
      
      if (readCookie('first_name') != null && readCookie('seller_email') != null && readCookie('brand_name') != null && readCookie('session_token') != null) {
        var forgotPasswordPopup = $('.changePassword-popup');
        forgotPasswordPopup.bPopup({
          positionStyle: 'fixed',
          closeClass: 'modal__close'
        }); 
      } else {
         //Do nothing.
      }
    }
});

//Function checks for the valid email id. 
function validateEmail(seller_mail_id) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(seller_mail_id);
}

function createCookie(name, value, days) {
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    var expires = "; expires=" + date.toGMTString();
  } else var expires = "";
  document.cookie = name + "=" + value + expires + "; path=/";
}
